import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faScreenUsers } from '@fortawesome/pro-solid-svg-icons/faScreenUsers';
import { faSquareList } from '@fortawesome/pro-solid-svg-icons/faSquareList';
import { faSquarePlus } from '@fortawesome/pro-solid-svg-icons/faSquarePlus';
import { useTranslation } from 'react-i18next';
import { Icon } from 'src/shared/components/icon';
const Tag = ({ type }) => {
    const { t } = useTranslation();
    const typeMap = {
        main: { label: t('content_list.module_card.main_type_badge'), icon: faSquareList },
        extra: { label: t('content_list.module_card.extra_type_badge'), icon: faSquarePlus },
        mentorship: { label: t('content_list.module_card.mentorship_type_badge'), icon: faScreenUsers }
    };
    return (_jsxs("div", { className: "flex items-center gap-1 rounded-medium border-radius border-small border-neutral-300 bg-neutral-200 px-2 py-1 md:py-0", children: [_jsx(Icon, { icon: typeMap[type].icon, size: "xs" }), _jsx("p", { className: "hidden whitespace-nowrap text-extrasmall font-bold text-neutral-800 md:inline-block", children: typeMap[type].label })] }));
};
export default Tag;
